<template>
	<ViewWrapper :carregando="loading" :permissao="PERMISSOES_FGTAS.CADASTRAR_VAGA">
		<template #titulo>
			{{ editando ? "Edição" : "Cadastro" }} de Vaga
		</template>
		<v-container fluid>
			<v-card flat rounded class="pa-8 mt-4">
				<v-row justify="center">
					<v-col cols="12">
						<v-tabs
						v-model="tab"
						:color="corTexto"
						align-tabs="center"
						>
							<v-tab
								v-for="passo in passos"
								:key="passo.value"
								:text="passo.label"
								:value="passo.value"
								:readonly="passo.disabled || !formDesabilitado"
								/>
						</v-tabs>

						<v-tabs-window v-model="tab">
							<v-tabs-window-item :value="0">
								<IdentificacaoEmpregador
									v-if="tab === 0"
									:key="tab"
									class="mt-8"
									:empregador-form="empregadorForm"
									:empregador-form-contratante="empregadorFormContratante"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="false"
									:modo-solicitacao="false"
									@proximo-passo="proximoPasso"
									/>
							</v-tabs-window-item>
							<v-tabs-window-item :value="1">
								<DadosVaga
									v-if="tab === 1"
									:key="tab"
									class="mt-8"
									:dados-vaga-form="dadosVagaForm"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="false"
									:modo-solicitacao="false"
									@proximo-passo="proximoPasso"
									@passo-anterior="voltarPasso"
									/>
							</v-tabs-window-item>
							<v-tabs-window-item :value="2">
								<Requisitos
									v-if="tab === 2"
									:key="tab"
									class="mt-8"
									:requisitos-form="requisitosForm"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="false"
									:modo-solicitacao="false"
									@proximo-passo="proximoPasso"
									@passo-anterior="voltarPasso"
									/>
							</v-tabs-window-item>
							<v-tabs-window-item :value="3">
								<DadosEntrevista
									v-if="tab === 3"
									:key="tab"
									class="mt-8"
									:dados-entrevista-form="dadosEntrevistaForm"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="false"
									:modo-solicitacao="false"
									@passo-anterior="voltarPasso"
									/>
							</v-tabs-window-item>
						</v-tabs-window>
					</v-col>
				</v-row>
			</v-card>
		</v-container>
	</ViewWrapper>
</template>
<script setup>
import { useRoute, useRouter } from 'vue-router'
import { ref, onMounted, watch, computed } from 'vue';
import ViewWrapper from '@/components/commons/wrapper/ViewWrapper.vue';
import IdentificacaoEmpregador from '@/components/vagas/passos/IdentificacaoEmpregador.vue';
import DadosVaga from '@/components/vagas/passos/DadosVaga.vue';
import Requisitos from '@/components/vagas/passos/Requisitos.vue';
import DadosEntrevista from '@/components/vagas/passos/DadosEntrevista.vue';
import { vagasEnum } from '@/utils/VagaUtils';
import { buscarVaga } from '@/services/VagaService';
import { ErroAlert } from "@/utils/AlertUtils.js";
import { vuetify } from '@/plugins/vuetify'
import { PERMISSOES_FGTAS } from '@/utils/PermissaoUtils';


const route = useRoute();
const router = useRouter();
const loading = ref(false);
const editando = ref(false);
const formDesabilitado = ref(false);

const passos = ref([
	{ label: "Identificação do Empregador", value: 0, disabled: false },
	{ label: "Dados da VAGA", value: 1, disabled: true },
	{ label: "Requisitos", value: 2, disabled: true },
	{ label: "Dados da Entrevista", value: 3, disabled: true },
]);
const dataVaga = ref();

const empregadorForm = ref({
	id: editando.value ? Number(route.params?.id) : undefined,
	tipoIdentificacao: "CNPJ",
	numeroIdentificacao: "",
	razaoSocial: "",
	logradouro: "",
	numero: "",
	bairro: "",
	cep: "",
	uf: "",
	cidade: "",
	tipoLogradouro: undefined,
	referenciaAcesso: "",
	telefone: "",
	utilizaWhatsApp: undefined,
	email: "",
	responsavelSINE: "",
	cargo: "",
	outroContratante: undefined,
});

const empregadorFormContratante = ref({
	tipoIdentificacao: "CNPJ",
	numeroIdentificacao: "",
	razaoSocial: "",
});

const dadosVagaForm = ref({
	id: editando ? Number(route.params?.id) : undefined,
	ocupacao: undefined,
	cbo: undefined,
	numeroVagas: undefined,
	salarioMensal: undefined,
	descricaoAtividades: undefined,
	logradouro: undefined,
	numero: undefined,
	bairro: undefined,
	cep: undefined,
	uf: undefined,
	cidade: undefined,
	tipoLogradouro: undefined,
	referenciaAcesso: undefined,
	enderecoTrabalhoIgual: undefined,
	horarioTrabalho: undefined,
	pcd: undefined,
	tipoContratacao: undefined,
	instituicao: undefined,
	nomeCurso: undefined,
	dataInicioCurso: undefined,
	cargaHorariaTeoricaSemanal: undefined,
	cargaHorariaPraticaSemanal: undefined,
	beneficios: [],
	motivosContratacao: [],
	agencia: undefined,
})

const requisitosForm = ref({
	id: editando ? Number(route.params?.id) : undefined,
	experiencia: undefined,
	comprovacaoCTPS: undefined,
	escolaridadeMinima: undefined,
	tipoHabilitacao: undefined,
	observacoes: "",
})

const dadosEntrevistaForm = ref({
	id: editando ? Number(route.params?.id) : undefined,
	responsavel: undefined,
	cargo: undefined,
	local: undefined,
	listaDataHorario: [{ id: undefined, dataEntrevista: undefined, horarioEntrevista: undefined, unformattedData: undefined }],
	dataRetorno: undefined,
})

const tab = ref(passos.value[0].value);

function preenchePassos(vaga) {
	empregadorForm.value = {
		id: vaga.id || undefined,
		tipoIdentificacao: vaga.empregador.tipoIdentificacao || undefined,
		numeroIdentificacao: vaga.empregador.numeroIdentificacao || undefined,
		razaoSocial: vaga.empregador.razaoSocial || undefined,
		logradouro: vaga.empregador.endereco.logradouro || undefined,
		numero: vaga.empregador.endereco.numero || undefined,
		bairro: vaga.empregador.endereco.bairro || undefined,
		cep: vaga.empregador.endereco.cep || undefined,
		uf: vaga.empregador.endereco.municipio ? vaga.empregador.endereco.municipio.uf : undefined,
		cidade: vaga.empregador.endereco.municipio ? vaga.empregador.endereco.municipio : undefined,
		tipoLogradouro: vaga.empregador.endereco.tipoLogradouro || undefined,
		referenciaAcesso: vaga.empregador.endereco.referenciaAcesso || undefined,
		telefone: vaga.empregador.contato.telefone || undefined,
		utilizaWhatsApp: vaga.empregador.contato.utilizaWhatsApp || undefined,
		email: vaga.empregador.contato.email || undefined,
		responsavelSINE: vaga.empregador.contato.responsavelSINE || undefined,
		cargo: vaga.empregador.cargo || undefined,
		outroContratante: vaga.outroContratante || undefined,
	}
	if (vaga.outroContratante === "S") {
		empregadorFormContratante.value = {
			tipoIdentificacao: vaga.contratante.tipoIdentificacao || undefined,
			numeroIdentificacao: vaga.contratante.numeroIdentificacao || undefined,
			razaoSocial: vaga.contratante.razaoSocial || undefined,
		}
	}
	const mappedBeneficios = vaga.beneficios
		? vaga.beneficios.map((beneficio) => {
			return {
				...beneficio.tipoBeneficio,
				complemento: beneficio.complemento,
				idBeneficio: beneficio.id,
			}
		})
		: []
	const mappedMotivoContratacao = vaga.motivosContratacao
		? vaga.motivosContratacao.map((motivo) => {
			return {
				...motivo.motivoContratacao,
				idMotivo: motivo.id,
			}
		})
		: []
	dadosVagaForm.value = {
		id: vaga.id || undefined,
		ocupacao: vaga.ocupacao || undefined,
		cbo: vaga.cbo || undefined,
		numeroVagas: vaga.numeroVagas || undefined,
		salarioMensal: vaga.salarioMensal || undefined,
		descricaoAtividades: vaga.descricaoAtividades || undefined,
		enderecoTrabalhoIgual: vaga.enderecoTrabalhoIgual || undefined,
		logradouro: vaga.enderecoLocalTrabalho.logradouro || undefined,
		numero: vaga.enderecoLocalTrabalho.numero || undefined,
		bairro: vaga.enderecoLocalTrabalho.bairro || undefined,
		cep: vaga.enderecoLocalTrabalho.cep || undefined,
		uf: vaga.enderecoLocalTrabalho.municipio ? vaga.enderecoLocalTrabalho.municipio.uf : undefined,
		cidade: vaga.enderecoLocalTrabalho.municipio ? vaga.enderecoLocalTrabalho.municipio : undefined,
		tipoLogradouro: vaga.enderecoLocalTrabalho.tipoLogradouro || undefined,
		referenciaAcesso: vaga.enderecoLocalTrabalho.referenciaAcesso || undefined,
		horarioTrabalho: vaga.horarioTrabalho || undefined,
		pcd: vaga.pcd || undefined,
		tipoContratacao: vaga.tipoContratacao || undefined,
		instituicao: vaga.curso.instituicao || undefined,
		nomeCurso: vaga.curso.nomeCurso || undefined,
		dataInicioCurso: vaga.curso.dataInicioCurso || undefined,
		cargaHorariaTeoricaSemanal: vaga.curso.cargaHorariaTeoricaSemanal || undefined,
		cargaHorariaPraticaSemanal: vaga.curso.cargaHorariaPraticaSemanal || undefined,
		tipoContratacao: vaga.tipoContratacao || undefined,
		periodoContratacao: vaga.periodoContratacao || undefined,
		beneficios: mappedBeneficios,
		motivosContratacao: mappedMotivoContratacao,
		agencia: vaga.agencia.id ? vaga.agencia : undefined,
	}
	requisitosForm.value = {
		id: vaga.id || undefined,
		experiencia: vaga.requisitos.experiencia || undefined,
		comprovacaoCTPS: vaga.requisitos.comprovacaoCTPS || undefined,
		escolaridadeMinima: vaga.requisitos.escolaridadeMinima && vaga.requisitos.escolaridadeMinima.id ? vaga.requisitos.escolaridadeMinima : undefined,
		tipoHabilitacao: vaga.requisitos.tipoHabilitacao && vaga.requisitos.tipoHabilitacao.id ? vaga.requisitos.tipoHabilitacao : undefined,
		observacoes: vaga.requisitos.observacoes || undefined,
	}
	const mappedListaDataHorario = vaga.dadosEntrevista.listaDataHorario
		? vaga.dadosEntrevista.listaDataHorario.map((data) => {
				const [dia, mes, ano] = data.dataEntrevista.split("/");
				return {
					id: data.id,
					dataEntrevista: data.dataEntrevista,
					horarioEntrevista: data.horarioEntrevista,
					unformattedData: new Date(ano, mes - 1, dia),
				}
		})
		: [{ id: undefined, dataEntrevista: undefined, horarioEntrevista: undefined, unformattedData: undefined }]
	dadosEntrevistaForm.value = {
		id: vaga.id || undefined,
		responsavel: vaga.dadosEntrevista.responsavel || undefined,
		cargo: vaga.dadosEntrevista.cargo || undefined,
		listaDataHorario: mappedListaDataHorario,
		local: vaga.dadosEntrevista.local || undefined,
		dataRetorno: vaga.dadosEntrevista.dataRetorno || undefined,
	}
}

async function buscarDadosVaga() {
	loading.value = true;
	await buscarVaga(route.params?.id || 0)
		.then(({ data }) => {
			dataVaga.value = data;
			if (dataVaga.value.dataFim) {
				router.push("/vagas/lista");
				return;
			}
			formDesabilitado.value = data.situacao !== "RASCUNHO"
			if (formDesabilitado.value) {
				passos.value[0].disabled = false;
				passos.value[1].disabled = false;
				passos.value[2].disabled = false;
				passos.value[3].disabled = false;
				tab.value = 0;
			}
			else if (dataVaga.value.stepCadastroVaga === vagasEnum[0]) {
				passos.value[0].disabled = false;
				passos.value[1].disabled = false;
				passos.value[2].disabled = true;
				passos.value[3].disabled = true;
				tab.value = 1;
			} else if (dataVaga.value.stepCadastroVaga === vagasEnum[1]) {
				passos.value[0].disabled = false;
				passos.value[1].disabled = false;
				passos.value[2].disabled = false;
				passos.value[3].disabled = true;
				tab.value = 2;
			} else if (dataVaga.value.stepCadastroVaga === vagasEnum[2] || dataVaga.value.stepCadastroVaga === vagasEnum[3]) {
				passos.value[0].disabled = false;
				passos.value[1].disabled = false;
				passos.value[2].disabled = false;
				passos.value[3].disabled = false;
				tab.value = 3;
			}
			preenchePassos(dataVaga.value);
		})
		.catch((error) => {
			router.push("/vagas/lista");
			ErroAlert({ mensagem: "Não foi possível encontrar vaga.", error });
		})
		.finally(() => loading.value = false);
}

const corTexto = computed(() => {
	return vuetify.theme.current.value.dark ? "white" : "primary";
})

async function proximoPasso() {
	if (tab.value === 3) {
		return;
	}
	if (!formDesabilitado.value) {
		loading.value = true;
		await buscarVaga(route.params?.id || 0)
			.then(({ data }) => {
				dataVaga.value = data;
				preenchePassos(dataVaga.value);
			})
			.catch((error) => {
				console.error(error.response.data.mensagem);
			})
			.finally(() => loading.value = false);
	}
	tab.value = tab.value + 1;
};

function voltarPasso() {
	tab.value = tab.value - 1;
};

watch(tab, () => {
	if (dataVaga.value) {
		preenchePassos(dataVaga.value);
	}
}, { immediate: true });

onMounted(async () => {
	if (!isNaN(route.params?.id)) {
		editando.value = true;
		await buscarDadosVaga();
	}
});
</script>